import { useAppSelector } from 'store/hooks';
import { useSidePanel } from 'features/side-panels/hooks/useSidePanel';
import { selectToolbarUserCount } from 'features/toolbar/toolbarSlice';
import { useParticipants } from 'features/users/useParticipants';

export const useParticipantsControl = () => {
  const userCount = useAppSelector(selectToolbarUserCount);

  const { isPanelVisible, togglePanel } = useSidePanel();

  const { canSeeParticipantsPanel, isFeatureAvailable } = useParticipants();

  const toggleParticipantsPanel = () => {
    togglePanel('users');
  };

  return {
    active: isPanelVisible('users'),
    totalParticipants: userCount,
    togglePanel: toggleParticipantsPanel,
    // icon: canSeeParticipantsPanel ? 'participants' : 'breakout-people-rooms',
    icon: canSeeParticipantsPanel ? 'participants' : 'breakout-rooms',
    isFeatureAvailable,
    canSeeParticipantsPanel,
  };
};
